var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"News"},[(_vm.view_type === 'newsMenu')?[_c('div',{model:{value:(_vm.readNewsMenu),callback:function ($$v) {_vm.readNewsMenu=$$v},expression:"readNewsMenu"}}),_c('NewsMenu',{attrs:{"cms_response":this.CMS_response}})]:_vm._e(),(_vm.view_type === 'detail')?[_c('NewsDetail',{on:{"catchTitle":_vm.setTitle}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }